export const CHIP_MAX_WIDTH = 220
